<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      :checkbox-config="{
        highlight: true,
        reserve: true,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.shipmentStatus === 'D' || row.shipmentStatus === 'R'
              ? 'warning'
              : row.shipmentStatus === 'N'
              ? 'primary'
              : 'success'
          "
        >
          {{ row.v_shipmentStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                openEditPage({
                  pageType: 'detail',
                  params: { code: row.shipmentCode },
                  query: { shipmentNo: row.shipmentNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="allow('M')"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                openEditPage({
                  pageType: 'edit',
                  params: { code: row.shipmentCode },
                  query: { shipmentNo: row.shipmentNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-dropdown trigger="click" @command="exportFile" v-if="allow('E')">
            <el-tooltip
              class="item"
              effect="dark"
              :content="$l('INDEX.btn_export') || '导出'"
              placement="top"
            >
              <i class="el-icon-download tool-btn"></i>
            </el-tooltip>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="{
                  ...row,
                  templateGroup: 'shipment-customsdeclaration',
                  exportCheckUrl: '/factory/shipmentPackingList/checkData',
                }"
              >
                {{ $l('INDEX.btn_export_customsdeclaration') || '导出 报关单' }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('btn_customs_declaration') || '报关完成'"
            placement="top"
            v-if="allow('C')"
          >
            <i
              class="el-icon-circle-check tool-btn"
              @click="finish(row.shipmentCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_fallback') || '回退'"
            placement="top"
            v-if="allow('D')"
          >
            <i class="el-icon-refresh-left tool-btn" @click="rollback(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <ChooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{
        custCode: chooseTemplateOptions.custCode,
        endCustCode: chooseTemplateOptions.endCustCode,
        templateGroup: chooseTemplateOptions.templateGroup,
      }"
      :exportOptions="{
        params: chooseTemplateOptions.exportParams,
        checkUrl: chooseTemplateOptions.exportCheckUrl,
      }"
    />
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
import ChooseTemplate from '@/views/factory/transport/components/choose-template'
export default {
  components: { ChooseTemplate },
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
      chooseTemplateOptions: {
        visible: false,
        custCode: '',
        endCustCode: '',
        templateGroup: '',
        exportCheckUrl: '',
        exportParams: {
          shipmentCode: '',
        },
      },
    }
  },
  methods: {
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'transport-wait-exportDeclaration-detail',
        params: { ...params, pageType },
        query,
      })
    },
    rollback(row) {
      this.$confirm(
        '确认要回退发运单【' + row.shipmentNo + '】吗？',
        '确认信息',
        {
          type: 'warning',
        }
      ).then(() => {
        this.rollbackSubmit(row)
      })
    },
    rollbackSubmit(data) {
      this.loadingOpen()
      this.$api
        .shipmentInfoBackApi({
          shipmentCode: data.shipmentCode,
          shipmentStatus: data.shipmentStatus,
        })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success',
            })
            this.$emit('reload')
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    finish(shipmentCode) {
      this.loadingOpen()
      this.$api
        .shipmentDeclarationCompletedApi({
          shipmentCode: shipmentCode,
        })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success',
            })
            this.$emit('reload')
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    exportFile({
      shipmentCode,
      custCode,
      endCustCode,
      templateGroup,
      exportCheckUrl,
    }) {
      this.chooseTemplateOptions = {
        visible: true,
        exportParams: { shipmentCode },
        custCode,
        endCustCode,
        templateGroup,
        exportCheckUrl,
      }
    },
  },
}
</script>
